<template>
    <div class="container">

        <br><br><br><br><br>

        <template v-if="configError">
            <ErrorNotification login/>
        </template>
        <template v-else>
            <div>Você será redirecionado em breve.</div>
            <small><a @click="redirectToFrontend">clique aqui</a> se você não for redirecionado.</small>
        </template>

        <!-- Filler para evitar que o footer fique estranho se demorar para fazer o redirecionamento -->
        <br><br><br><br><br>
        <br><br><br><br><br>
        <br><br><br><br><br>
        <br><br><br><br><br>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ErrorNotification from '@/components/AuthCommons/ErrorNotification'

export default {
    name: 'Login',
    created() {
        this.redirectToFrontend()
    },
    components: { ErrorNotification },
    data: vm => ({
        configError: false,
    }),
    methods: {
        redirectToFrontend() {
            if (!this.frontendUrl) {
                this.configError = true
                return
            }

            // Para desenvolvimento, o frontend vai rodar na porta 8081
            // Em produção, vai rodar em um subdomínio app.cliente.com
            window.location = this.frontendUrl
        },
    },
    computed: {
        ...mapGetters({
            frontendUrl: 'company/frontend_domain'
        }),
    },
}
</script>